import React, {useContext, useState, Component} from 'react';
import { AuthContext } from "../../Auth.js"
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import DateUtilities from '../../componentes/DateUtilities'
import WeekPisca from './weekPisca'
import moment from 'moment'

function Inicio() {
    const { currentUser } = useContext(AuthContext)
    const [userName] = useState(currentUser.name)

    return (
    <div>
        <Pisca userName={userName} />
    </div>
    )
}

class Pisca extends Component{
    constructor(props){
        super(props)
        this.state={
            empleado:this.props.userName,
            piscaSemana:[],
            totalPisca:0,
            dateFilter:'pastWeek',
            firstDate:'',
            inicioTemp:DateUtilities.getFirstDayOfTemp(),
            secondDate:'',
            zona:'',
        }
        this.unsubscribe=null
    }
    setReference=()=>{
        let dbReference=firebase.firestore().collection('Produccion')
        dbReference=this.filterByEmployee(dbReference)
        dbReference=this.filterByDate(dbReference)
        return dbReference
    }
    filterByDate=(dbReference)=>{
        return dbReference.where('fecha', '>=', this.state.inicioTemp)
    }
    filterByEmployee=(dbReference)=>{
        return dbReference.where('empleado', '==', this.state.empleado)
    }
    getWeekAndYear=(date)=>{
        let momentDate=moment(date)
        let dayOfTheWeek=momentDate.day()
        let year=momentDate.year()
        let week=dayOfTheWeek>=4 
            ? moment(DateUtilities.addDays(date, 3)).week()
            : momentDate.week() 
        return`${week} ${year}`
    }
    GetData=()=>{
		this.unsubscribe=this.setReference().orderBy('fecha','desc').onSnapshot(datos=>{
            try{
                const datosArray=[]
                let weekIndex=-1
                //let weekIndexMap={}
                for(let i=0; i<datos.size;i++){
                    const dato=datos.docs[i]
                    const date=datos.docs[i].data().fecha.toDate()
                    const weekAndYear=this.getWeekAndYear(date)
                    if(datosArray.length===0 || datosArray[weekIndex].weekAndYear!==weekAndYear){
                        datosArray.push({
                            weekAndYear:weekAndYear, 
                            weeks:[], 
                            total:0,
                            harvestActivities:[],
                            activities:[],
                            unidades:"",
                        })
                        weekIndex++
                        //weekIndexMap={}
                    }
        
                    if(dato.data().fruta === "Frambuesa"){
                        datosArray[weekIndex].total+=dato.data().totalBotes
                        datosArray[weekIndex].unidades="Botes"
                    } else if (dato.data().fruta === "Zarzamora"){
                        datosArray[weekIndex].total+=dato.data().totalCajas*4
                        datosArray[weekIndex].unidades="Medios Botes"
                    } else {
                        datosArray[weekIndex].total=0
                    }

                    if(dato.data().fruta==='Zarzamora'){
                        datosArray[weekIndex].harvestActivities.push({
                            id:dato.id,
                            fruta:dato.data().fruta,
                            variedad:dato.data().variedad,
                            sector:dato.data().sector,
                            fecha:dato.data().fecha.toDate().toLocaleDateString(),
                            estado:dato.data().estado,
                            totalCajas:dato.data().totalCajas,
                        })
                    }else{
                        datosArray[weekIndex].activities.push({
                            id:dato.id,
                            fruta:dato.data().fruta,
                            variedad:dato.data().variedad,
                            sector:dato.data().sector,
                            fecha:dato.data().fecha.toDate().toLocaleDateString(),
                            estado:dato.data().estado,
                            totalBotes:dato.data().totalBotes,
                        })
                    }
                }
                this.setState({
                    piscaSemana:datosArray,
                    totalPisca: datosArray.reduce((suma, currentValue) => suma = suma + currentValue.total,0),
                })
            }
            catch(e){
                console.log(e)
            }
        })
    }
    componentDidMount(){
        this.GetData()
    }
    render(){
        return(
            <section>
                <h2>Total Piscado Esta Temporada = {this.state.totalPisca}</h2>
                {
                    this.state.piscaSemana.map((week, i)=>{
                        return <WeekPisca 
                        key={i} 
                        week={week} 
                        
                        />
                    })
                }
            </section>
        )
    }
}

export default Inicio;